import type { ITransactionsFilter } from '~/interfaces/dto/wallet/transactions';

const transactionsFilter = ref<ITransactionsFilter>(null);

const isTransactionsFilterEmpty = computed(() => {
  if (!transactionsFilter.value) return true;
  return Object.keys(transactionsFilter.value).length === 0;
});

export default () => ({
  transactionsFilter,
  isTransactionsFilterEmpty,
});
